import React, { memo } from 'react';
import { CmhcFlexIcon } from '@cmhc-schl/hearth-ui';
import { Box, Typography } from '@mui/material';
import styles from './styles.module.scss';

const LenderDetails = ({ lenderCode, lenderName }: { lenderCode: string; lenderName?: string }) => {
  return (
    <Box className={styles.lenderDetails}>
      <Box className={styles.lenderInfo}>
        <CmhcFlexIcon className={styles.iconLender} width={48} height={48} type="icon_lender" />
        <Box className={styles.lenderContainer}>
          <Box sx={{ width: '100%' }}>
            <Typography className={styles.insuredName}>{lenderName}</Typography>

            <Typography variant="body2">{lenderCode}</Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default memo(LenderDetails);
